export const obj1 = {
  title: "1. Session Cancellation by Members",
  subTitle: "If you need to cancel a confirmed 1-on-1 session with a Specialist, the following refund rules apply based on your cancellation timing:",
  list: [
    {
      key: "Standard Cancellations (24+ Hours Notice):",
      summary: "If you cancel your appointment 24 hours or more before the scheduled start time, you will receive a 100% full refund of the appointment fee.",
    },
    {
      key: "Late Cancellations (Less than 24 Hours Notice):",
      summary: "If you cancel your appointment less than 24 hours before the scheduled start time, no refund (0% refund) will be issued. This ensures specialists are fairly compensated for reserved time slots.",
    },
  ]
}

export const obj2 = {
  title: "2. Rescheduling Policy",
  subTitle: "If you wish to reschedule an appointment with a Specialist:",
  list: [
    {
      summary: "Rescheduling is permitted without penalty up to 24 hours prior to the scheduled start time."
    },
    {
      summary: "Attempting to reschedule within the 24-hour window before a session will automatically cancel the existing slot under the late cancellation policy (no refund). A new session must be booked separately."
    }
  ]
}

export const obj3 = {
  title: "3. Cancellations by Specialists",
  subTitle: "In the rare event that a Specialist cancels your scheduled session:",
  list: [
    {
      summary: "You will automatically receive a 100% full refund to your original payment method."
    },
    {
      summary: "Our platform will notify you immediately via email so you can rebook with another Specialist or select a new time slot."
    }
  ]
}

export const obj4 = {
  title: "4. Attendance & No-Show Policy",
  subTitle: "To ensure fair practices and maintain accountability on our platform, missed sessions are handled as follows:",
  list: [
    {
      key: "Specialist No-Show:",
      summary: "If a Specialist fails to join a scheduled session and you mark them as a no-show, our system will verify attendance records. Upon verification, you will receive a 100% full refund, and an administrative strike will be recorded against the Specialist.",
    },
    {
      key: "Member No-Show:",
      summary: "If you fail to attend a scheduled session and the Specialist marks you as a no-show, no refund will be issued, and the Specialist will receive their full payout.",
    },
  ]
}

export const obj5 = {
  title: "5. Subscriptions & Free Trial Rules",
  subTitle: "For recurring membership subscriptions and wellness packages:",
  list: [
    {
      summary: "Free Trials: If you register for a free trial, your payment card will not be charged during the trial period. You may cancel anytime before the trial ends to avoid all charges."
    },
    {
      summary: "Auto-Renewal: Subscriptions automatically renew at the end of each billing cycle (monthly or annually) unless cancelled in your account settings prior to the billing renewal date."
    },
    {
      summary: "Non-Refundable Subscription Fees: Processed subscription and renewal fees are non-refundable. We do not provide prorated refunds or credits for partial subscription billing periods."
    }
  ]
}

export const obj6 = {
  title: "6. Refund Processing & Timelines",
  subTitle: "All approved and eligible refunds are handled systematically:",
  list: [
    {
      summary: "Approved refunds are processed automatically back to the original payment method (e.g., credit card, debit card) used during purchase."
    },
    {
      summary: "Refunds typically take 5 to 10 business days to appear on your bank statement, depending on your financial institution's processing times."
    }
  ]
}
